import axios from "axios";

const SAVE_CONSENT_URL =
  "https://tmpointegrationfaxes.azurewebsites.net/api/287/save-consent";

const STATIC_PAYLOAD = {
  channel: "",
  identifier: "",
  preference: "",
  source: "TrueMed",
};

/**
 * Save consent using the WellNow integration endpoint.
 * POST .../api/287/save-consent?ticket={ticket}
 */
const saveConsent = (ticket: string) => {
  // Keep base64 padding (==) unencoded so the ticket matches the page URL.
  return axios.post(`${SAVE_CONSENT_URL}?ticket=${ticket}`, STATIC_PAYLOAD);
};

const ConsentService = {
  saveConsent,
};

export default ConsentService;
